import { render, staticRenderFns } from "./TeammateWidget.vue?vue&type=template&id=5bac3428&scoped=true"
import script from "./TeammateWidget.vue?vue&type=script&lang=js"
export * from "./TeammateWidget.vue?vue&type=script&lang=js"
import style0 from "./TeammateWidget.vue?vue&type=style&index=0&id=5bac3428&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bac3428",
  null
  
)

export default component.exports